import { Col } from '@/components';
import { AccountingTypeSelectField } from '@/features/master-table/components';
import { useGetReferenceFiscalYearBySearchType } from '@/features/search/_hooks/projects-search';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const AccountingTypeIdsColField: FC = memo(() => {
  const { t } = useTranslation();
  const { control: sharedSearchControl } =
    useFormContext<SharedSearchFormType>();
  const { control: analysisSearchControl } =
    useFormContext<AnalysisSearchFormType>();
  const referenceFiscalYear = useGetReferenceFiscalYearBySearchType();

  const analysisTarget = useWatch({
    control: analysisSearchControl,
    name: 'analysisTarget',
  });
  const [sheetType, accountingType] = useWatch({
    control: sharedSearchControl,
    name: ['sheetType', 'accountingType'],
  });

  if (sheetType !== 'RS' || analysisTarget === 'payment') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <AccountingTypeSelectField
        name="accountingTypeIds"
        label={t('accounting-name')}
        fiscalYear={referenceFiscalYear ?? null}
        type={accountingType}
        allowClear
        mode="multiple"
        width="100%"
        tagMaxWidth={110}
        disabled={accountingType !== 'special'}
      />
    </Col>
  );
});
